import $ from 'jquery';
import {Easings, smoothy} from "../Libraries/smoothy";

$('.back-to-top').on('click', function () {
    smoothy(0, 1000, Easings.easeOutQuint);
});

$(document).on('scroll', function () {
    if ($(window).width() > 768) {
        if ($(document).scrollTop() < 720) {
            $('.back-to-top').addClass('hide');
        } else {
            $('.back-to-top').removeClass('hide');
        }
    } else {
        if ($(document).scrollTop() < 420) {
            $('.back-to-top').addClass('hide');
        } else {
            $('.back-to-top').removeClass('hide');
        }
    }
});
